import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { NavigationBackResolve } from './navigation-back.resolve';
import { NavigationBuilder } from './navigation.builder';
import { NavigationService } from './navigation.service';

@NgModule({
  imports: [CommonModule, RouterModule, SharedModule],
})
export class NavigationModule {
  static forRoot(): ModuleWithProviders<NavigationModule> {
    return {
      ngModule: NavigationModule,
      providers: [NavigationService, NavigationBuilder, NavigationBackResolve],
    };
  }
}
